module.exports = __webpack_public_path__ + "img/1536871333.2f990d3e.jpg";